
export function CEOSection() {
  return (
    <section id="ceo-section" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* CEO Message */}
          <div>
            <h3 className="text-4xl font-bold text-gray-900 mb-8 text-center">
              대표인사말
            </h3>
            
            <div className="space-y-8 text-gray-600 leading-relaxed">
              <p className="text-lg text-center mb-8">
                안녕하세요.<br />
                ㈜라코스벨 대표이사 정주연입니다.
              </p>
              
              <p className="text-center text-gray-600">
                라코스벨은 <strong className="text-gray-900">'자연이 가진 치유의 힘을 현대의 기술로 정제한다'</strong>라는 
                신념으로 시작되었습니다.<br />
                저희는 단순히 화장품을 만드는 것이 아니라 자연과 사람이 연결되는 경험을 제공합니다.
              </p>
              
              <div className="bg-emerald-50 p-8 rounded-xl border-l-4 border-emerald-500 mx-auto max-w-3xl">
                <p className="text-emerald-800 font-medium text-center">
                  지속 가능한 가치, 정직한 원료, 그리고 진심이 담긴 향 —<br />
                  이 세 가지는 라코스벨이 결코 타협하지 않는 원칙입니다.
                </p>
              </div>
              
              <p className="text-center text-gray-600">
                앞으로도 자연이 전하는 순수한 에너지를 통해 여러분의 피부와 마음에 편안한 휴식을 전할 수 있도록 노력하겠습니다.
              </p>
              
              <p className="text-gray-900 font-medium text-center mt-8">
                감사합니다.<br />
                대표이사 정주연 드림
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
